// C:\Users\EYG\fynwise-website\src\components\ui\grid-background.tsx
"use client"
import * as React from "react"

export function GridBackground() {
  return (
    <div
      className="absolute inset-0 pointer-events-none w-full h-full"
      style={{
        background: "radial-gradient(circle at center, rgba(16, 185, 129, 0.08), rgba(0, 0, 0, 0.5) 70%)",
        zIndex: 0,
      }}
    >
      <div
        className="absolute inset-0 w-full h-full"
        style={{
          backgroundImage: `
            linear-gradient(to right, rgba(255,255,255,0.015) 1px, transparent 1px),
            linear-gradient(to bottom, rgba(255,255,255,0.015) 1px, transparent 1px)
          `,
          backgroundSize: "20px 20px",
        }}
      />
      
      {/* Moving light effects */}
      <div 
        className="absolute -top-40 -left-40 h-80 w-80 rounded-full bg-emerald-500/10 blur-3xl opacity-10 animate-pulse"
        style={{ animationDuration: '8s' }}
      ></div>
      
      <div 
        className="absolute top-1/3 -right-20 h-60 w-60 rounded-full bg-white/5 blur-3xl opacity-10 animate-pulse"
        style={{ animationDuration: '12s' }}
      ></div>
      
      {/* Mobile-responsive grid size */}
      <div 
        className="absolute inset-0 sm:hidden w-full h-full"
        style={{
          backgroundImage: `
            linear-gradient(to right, rgba(255,255,255,0.015) 1px, transparent 1px),
            linear-gradient(to bottom, rgba(255,255,255,0.015) 1px, transparent 1px)
          `,
          backgroundSize: "15px 15px",
        }}
      />
    </div>
  )
}